import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import PageHeader1 from '../../components/common/PageHeader1';
import axios from "axios";
import apiClient from "../../utils/api";
import EditButton from "../../components/common/EditButton";
import DeleteButton from "../../components/common/DeleteButton";

function RolesList() {
    const deletbutton1 = () => {
        const Row1 = document.getElementById('row1')
        if (Row1) {
            Row1.setAttribute("style", "display:none");
        }
    }
    const deletbutton2 = () => {
        const Row1 = document.getElementById('row2')
        if (Row1) {
            Row1.setAttribute("style", "display:none");
        }
    }
    const deletbutton3 = () => {
        const Row1 = document.getElementById('row3')
        if (Row1) {
            Row1.setAttribute("style", "display:none");
        }
    }
    const deletbutton4 = () => {
        const Row1 = document.getElementById('row4')
        if (Row1) {
            Row1.setAttribute("style", "display:none");
        }
    }
    const deletbutton5 = () => {
        const Row1 = document.getElementById('row5')
        if (Row1) {
            Row1.setAttribute("style", "display:none");
        }
    }
    const deletbutton6 = () => {
        const Row1 = document.getElementById('row6')
        if (Row1) {
            Row1.setAttribute("style", "display:none");
        }
    }
    const deletbutton7 = () => {
        const Row1 = document.getElementById('row7')
        if (Row1) {
            Row1.setAttribute("style", "display:none");
        }
    }
    const deletbutton8 = () => {
        const Row1 = document.getElementById('row8')
        if (Row1) {
            Row1.setAttribute("style", "display:none");
        }
    }
    const deletbutton9 = () => {
        const Row1 = document.getElementById('row9')
        if (Row1) {
            Row1.setAttribute("style", "display:none");
        }
    }
    const deletbutton10 = () => {
        const Row1 = document.getElementById('row10')
        if (Row1) {
            Row1.setAttribute("style", "display:none");
        }
    }
    const deletbutton11 = () => {
        const Row1 = document.getElementById('row11')
        if (Row1) {
            Row1.setAttribute("style", "display:none");
        }
    }
    const deletbutton12 = () => {
        const Row1 = document.getElementById('row12')
        if (Row1) {
            Row1.setAttribute("style", "display:none");
        }
    }

    const [roles, setRoles] = useState([]);

    const fetchRoles = async (page = 1) => {
        try {
            const token = localStorage.getItem('auth_token');
            const response = await apiClient.get('accounts/roles',{
                headers: { Authorization: `Bearer ${token}` }
            });
            setRoles(response.data.data);
        } catch (error) {
            console.error('Error:', error);
        }
    };

    useEffect(() => {
        fetchRoles();
    }, []);

    const deleteApi = async (id) => {
        if (!window.confirm('Are you sure you want to delete this API key?')) {
            return;
        }

        try {
            const token = localStorage.getItem('auth_token');
            await apiClient.delete(`accounts/roles/${id}`,{
                headers: { Authorization: `Bearer ${token}` }
            });
            fetchRoles();

        } catch (error) {
            console.error('Error deleting API key:', error);
        }
    };

    return (
        <div className="body d-flex py-3">
            <div className="container-xxl">
                {/* <PageHeader1 pagetitle='Roles List' righttitle='Add Roles' link='/accounts/roles-add' routebutton={true}/> */}
                <div className="row g-3 mb-3">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-body">
                                <div id="myDataTable_wrapper" className="dataTables_wrapper dt-bootstrap5 no-footer">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className='table-responsive'>
                                                <table id="myDataTable"
                                                       className="table table-hover align-middle mb-0 nowrap dataTable no-footer dtr-inline"
                                                       style={{width: '100%'}} role="grid"
                                                       aria-describedby="myDataTable_info">
                                                    <thead>
                                                    <tr role="row">
                                                        <th className="sorting_asc" tabIndex="0"
                                                            aria-controls="myDataTable" rowSpan="1" colSpan="1"
                                                            style={{width: '32.2px'}}
                                                            aria-label="Id: activate to sort column descending"
                                                            aria-sort="ascending">Id
                                                        </th>
                                                        <th className="sorting" tabIndex="0"
                                                            aria-controls="myDataTable" rowSpan="1" colSpan="1"
                                                            style={{width: '117.2px'}}
                                                            aria-label="Categorie: activate to sort column ascending">Name
                                                        </th>

                                                        <th className="dt-body-right sorting" tabIndex="0"
                                                            aria-controls="myDataTable" rowSpan="1" colSpan="1"
                                                            style={{width: '75.2px'}}
                                                            aria-label="Action: activate to sort column ascending">Action
                                                        </th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {roles.map((role, index) => (
                                                        <tr id={index} role="row"
                                                            className={index % 2 === 0 ? 'odd' : 'even'}>
                                                            <td className="sorting_1" tabIndex="0">#{index + 1}</td>
                                                            <td className="sorting_1" tabIndex="0">{role.name}</td>
                                                            <td className=" dt-body-right">
                                                                <div className="btn-group" role="group"
                                                                     aria-label="Basic outlined example">                                                                    <EditButton
                                                                        to={`${process.env.PUBLIC_URL}/accounts/roles-edit/${role.id}`}
                                                                        permission="roles.edit"
                                                                    />
                                                                    <DeleteButton
                                                                        onDelete={() => deleteApi(role.id)}
                                                                        permission="roles.delete"
                                                                    />
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default RolesList;